import React, { useState, useEffect, useRef } from "react";
import { addDestination } from "../../apis/firebase";
import { DestinationType } from "../../constants";
import { addUserDestination, getUser } from "../../state/User";
import Check from "../utils/icons/Check";

import Close from "../utils/icons/Close";
import { closePopUp, showLoadingPopUp, showPopUp } from "../utils/Overlay";

function CustomBackendForm({ onSuccess }: { onSuccess: Function }) {
  const [endpoint, setEndpoint] = useState("");
  const endpointInput = useRef(null);
  const user = getUser();

  useEffect(() => {
    endpointInput.current.focus();
  }, []);

  return (
    <div className="cf">
      <h3 className="tac">Type the URL of your endpoint.</h3>
      <input
        type="text"
        className="block mt1"
        placeholder="Endpoint"
        ref={endpointInput}
        value={endpoint}
        onChange={(e) => {
          setEndpoint(e.target.value);
        }}
      />
      <div className="right">
        <button
          type="button"
          className="reset as-link ib fz1 with-icon"
          onClick={() => {
            closePopUp();
          }}
        >
          <Close size={20} /> Cancel
        </button>
        <button
          type="button"
          className="reset secondary ml1 with-icon"
          onClick={() => onSuccess(endpoint, user)}
          disabled={endpoint === ""}
        >
          <Check size={16} /> Ok
        </button>
      </div>
    </div>
  );
}

export function connectToCustomBackend() {
  showPopUp(
    <CustomBackendForm
      onSuccess={async (endpoint, user) => {
        showLoadingPopUp(
          <>
            Linking to your custom
            <br />
            back-end endpoint.
          </>
        );
        const newDestination = await addDestination(
          user,
          DestinationType.CUSTOM_BACKEND,
          { endpoint },
          {
            name: endpoint.replace(/(https|http):\/\//, ""),
          }
        );
        addUserDestination(newDestination);
        closePopUp();
      }}
    />,
    {
      width: "450px",
    }
  );
}
